<template>
  <div class="container">
    <app-header title="账单明细"/>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(index)" :class="activeTag==index ? 'active':''">{{item}}</div>
        </div>
      </div>
    </div>

    <template  v-if="show==true" >
      <div class="recharge" v-for="(item,index) in reChargeList" :key='index'>
        <div class="rechargeme">
          <div class="title" style="display: flex;height: 10px;"><p style="width: 25px;height: 25px;line-height: 25px;text-align: center;color: #999999;font-size: 15px;font-weight: 600;border: 2px #999999 solid;border-radius: 50%;">{{index + 1}}</p><p style="position: relative;left: 10px;top: 4px;">账户充值</p></div>
          <div class="price">+ {{item.money}}</div>
        </div>
        <div class="redate">{{item.createTime}}</div>
      </div>
      <empty v-if="reChargeList.length == 0"/>
    </template>

    <template  v-if="show==false" >
      <div v-if="show==false" class="recharge" v-for="(item,index) in productList" :key='index'>
        <div class="rechargeme">
          <div class="title" style="flex: 1;">购买产品 ({{item.title}})</div>
          <div class="price">- {{item.money}}</div>
        </div>
        <div class="redate">{{item.createTime}}</div>
      </div>
      <empty v-if="productList.length == 0"/>
    </template>

  </div>

</template>

<script>
import { queryShopChargeList,queryConsumRecordList } from '@/api/mine/reCharge.js'
import { getOrderAndProduct } from '@/api/order/index.js'
export default {
  name: 'Detail',
  data() {
    return {
      show: true,
      activeTag: 0,
      tabList: ['充值明细', '消费记录'],
      reChargeList:[],
      productList:[]
    }
  },
  created() {
    this._queryShopChargeList()
    this._queryConsumRecordList()
  },
  methods: {
    // 充值记录
    _queryShopChargeList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id,
        type: 0,
        resultCode: 1
      }
      queryShopChargeList(params).then((res) => {
        if (res.success){
          this.reChargeList = res.data
        }
      })
    },
    // 消费记录
    _queryConsumRecordList() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id
      }
      queryConsumRecordList(params).then((res) => {
        if(res.success){
          this.productList = res.data
        }
      })
    },
    handleTag(index) {
      this.activeTag = index
      if (index == 0) {
        this.show = true
      } else {
        this.show = false
      }
    }

  }
}
</script>
<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .recharge{
      padding: 22px;
      border-bottom: 2px solid #EDEDED;
      .rechargeme{
        display: flex;
        justify-content: space-between;
        .title{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(102,102,102,1);
          opacity:1;
        }
        .price{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(254,0,59,1);
          opacity:1;
        }
      }
      .redate{
        width:100%;
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(136,137,136,1);
        opacity:1;
        margin-top: 14px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/mine/detail.vue